import React, { ReactNode, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { rootState } from "../../../redux/store";
import { ParentModal } from "./ParentModal";
import { closeModal } from "./modal.slice";

interface IModalProps {
  modalKey: keyof rootState["modal"];
  children?: ReactNode;
  hasCloseIcon?: boolean;
}

export const Modal: React.FC<IModalProps> = ({ modalKey, children, hasCloseIcon = true }) => {

  const dispatch = useAppDispatch();
  const modalState = useAppSelector((state) => state.modal[modalKey]);
  
  const handleClose = () => {
    dispatch(closeModal(modalKey)); 
  };


  return (
    <ParentModal isOpen={modalState.isOpen} onTop={modalState.onTop} onClose={handleClose} hasCloseIcon={hasCloseIcon}>
      {children}
    </ParentModal>
  );
};
